import { useAuth } from 'context/authContext'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoute = () => {
    const { user } = useAuth()

    if (!user) {
        return <Navigate to="/auth/login" replace />
    }

    return <Outlet />
}

export default ProtectedRoute
